import React from "react";
import PropTypes from "prop-types";
// import cx from "classnames";
import { Form, 
    Button, Icon, 
    Modal, 
    List, 
    Radio,
    Statistic,
    Row,
    DatePicker,
    Col,
    message} from "antd";
import moment from "moment";

const START_DATE = "from_date";

class CompanyBounceChargeForm extends React.Component {
    state = {
        feeMaster: "",
        from_date:  this.props.feeData && this.props.feeData.toJS().from_date? moment(this.props.feeData && this.props.feeData.toJS().from_date, "YYYY-MM-DD"):null
    };

    onValuesSubmit = e => {
        e.preventDefault();
        if (!this.props.loading) {
            this.props.form.validateFields((err, values) => {
                if (!err && this.state.feeMaster && (this.state.from_date || this.props.update)) {
                    let newValues = values;
                    newValues.charge = this.state.feeMaster;
                    newValues.from_date = this.state.from_date && this.state.from_date.format("YYYY-MM-DD");
                    this.props.onValuesSubmit(newValues);
                }else{
                    message.error("Please enter valid values!");
                }
            });
        }
    }

    handleDateInput = (type, _) => {
        this.setState({
            [type]: _
        });
    };

    renderItem = (_, k) => {
        return (
            <List.Item onClick={() => this.setState({feeMaster: _.charge.id})}  className={"d-flex cursor-pointer align-items-start justify-content-flex-start flex-column"} key={k}>
                <h3>
                    {_.name || _.charge.name}
                </h3>
                <div className={"d-flex w-100"}>
                    <Radio 
                        onClick={() => this.setState({feeMaster: _.charge.id})}
                        className={"m-10"}
                        checked={this.state.feeMaster === _.charge.id}
                    />
                    <div className={"w-100 d-flex flex-column"}>
                    <Row className={"w-100 m-10"}>
                            <Col span={8}>
                                <Statistic title="Charge" value={_.charge.charge_json['charges']} valueStyle={{fontSize: 16}}/>
                            </Col>
                         </Row>
                    </div>
                </div>
            </List.Item>
        );
    }

    disabledDate = (current) => {
        // Disable dates before today (previous dates)
        return current && current < moment().startOf('day');
    }

    render() {
        return (
            <Modal 
                width={800}
                bodyStyle={{
                    paddingRight: "6rem",
                    paddingLeft: "6rem"
                }}
                footer={null}
                title="Add/Update Bounce Program"
                visible={this.props.visible}
                onCancel={this.props.toggleModal}
            >
                <Form onSubmit={this.onValuesSubmit}>
                    {!this.props.update && <div className={"form-row align-items-center"}>
                        <Row>
                            <Col span={12}>
                                <div className={"displayInline w-100"}>
                                    <p className={"required-field"} style={{ margin: "0px", paddingBottom: "8px" }}>From Date:</p><b />
                                    <div style={{ padding: "10 0 10 0" }}>
                                        <DatePicker
                                            disabledDate={this.disabledDate}
                                            style={{
                                                width: "100% !important"
                                            }}
                                            size={"default"}
                                            className={"w-date-picker"}
                                            onChange={this.handleDateInput.bind(
                                                null,
                                                START_DATE
                                            )}
                                            value={this.state.from_date}
                                            required={true}
                                            placeholder={"From Date"}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>}
                    <List
                        border={false}
                        className={"border-none"}
                        header={null}
                        bordered
                        footer={null}
                        dataSource={this.props.bounceChargesMaster}
                        renderItem={this.renderItem}
                    />
                    <div className={"form-row flex-row-reverse p-10"}>
                        <Button type={"primary"} htmlType={"submit"} disabled={this.props.loading}>
                            {this.props.loading ? <Icon type={"loading"} /> : null}
                            Add/Update
                        </Button>
                    </div>
                </Form>
            </Modal>
        );
    }
}

CompanyBounceChargeForm.propTypes = {
    form: PropTypes.object,
    values: PropTypes.array,
    onValuesSubmit: PropTypes.func,
    loading: PropTypes.bool,
    visible: PropTypes.visible,
    toggleModal: PropTypes.func,
    feeMaster: PropTypes.array,
    bounceChargesMaster: PropTypes.array
};

export default Form.create({})(CompanyBounceChargeForm);